export function renderLocaleTime(solidityDate) {
  const pet = new Date(solidityDate * 1000);
  return pet.toLocaleTimeString() + ' ' + pet.toLocaleDateString()
}

export function weiToMeow(wei) {
  let m = window.web3.utils.padLeft(wei, 40, '0');

  let fractionR = reverse(m.substr(27));

  const firstNonZero = fractionR.search("[^0]+")

  let fraction;

  if (firstNonZero > -1) {
    fraction = reverse(fractionR.substr(firstNonZero));
  }
  else {
    //fraction = reverse(fractionR);
    fraction = null;
  }

  let main = m.substr(0, 27);

  const firstValueIndex = main.search("[^0]+");
  if (firstValueIndex > -1) {
    main = main.substr(firstValueIndex);

    return main + (
      fraction ?
      '.' + fraction :
      '');
  }

  else {
    let r = '0';
    if (!fraction) return r;
    else return '0.' + fraction;
  }
}

export function weiToWholeMeow(wei) {
  const meow = weiToMeow(wei);

  return meow.split('.')[0];
}

function reverse(str) {
    var splitString = str.split("");
    var reverseArray = splitString.reverse();
    var joinArray = reverseArray.join("");
    return joinArray;
}
